<template>
  <div id="J_prismPlayer_courseVideo" />
</template>

<script>
/* eslint-disable */
export default {
  name: "courseVideo",
  props: {
    value: {
      type: [String],
      default: "",
    },
    isOrder: {
      type: Number,
      default: 0,
    },
    coverUrl: {
      type: String,
      default: "",
    },
    autoplay: {
      type: Boolean,
      default: false,
    },
    // 循环播放
    rePlay: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      player: null,
    };
  },
  methods: {
    initPlayer(source,sourceSign, params) {
      console.log(source)
      Aliplayer.__unable2Anti9Debugger13Key = 'error';
               if(sourceSign){
                let player2 = new Aliplayer({
                    "id": "J_prismPlayer_courseVideo",
                    "source": source,
                    "width": "100%",
                    "height": "100%",
                    "autoplay": false,
                    "isLive": false,
                    "rePlay": false,
                    "playsinline": true,
                    "preload": false,
                    "controlBarVisibility": "hover",
                    "useH5Prism": true
                },   (player2) => {
                  let video = null;
                  // 判断视频和音频获取对应标签
                  if (!this.isOrder) {
                    if (params.format == "mp3") {
                      video = document
                        .getElementById("J_prismPlayer_courseVideo")
                        .getElementsByTagName("video")[0];

                      var timeDisplay;
                      var tryTime;
                      var percent;

                    // 点击开始事件
                    video.addEventListener("timeupdate", () => {
                      //获取当前播放的时间
                      if (video.currentTime == video.duration) {
                        video.currentTime = 0;
                      }
                    });
                  }
                  }
                })
                    this.player = player2;
            }else{
      const player = new window.Aliplayer(
        {
          id: "J_prismPlayer_courseVideo",
          width: "100%",
          height: "100%",
          autoplay: false,
          cover: this.coverUrl || source.videoMeta.coverURL,
          // 下方是音频视频安全的版本
          vid: source.videoMeta.videoId,
          playauth: source.playAuth,
          encryptType: 1, // 加密类型，播放点播私有加密视频时，默认值为0，取值：0~1。
          qualitySort: "asc", // 指定排序方式，只有使用vid + plauth播放方式时支持 asc：示按正序排序（即：从小到大排序） 默认值：asc，仅H5支持。
          format: params.format,
          mediaType: params.mediaType,
          vodType: "1",
          type: "1", //音频1  视频空
          isLive: false,
          rePlay: false, // 播放器自动循环播放
          playsinline: true, // H5是否内置播放，有的Android浏览器不起作用。
          preload: false,
          controlBarVisibility: "hover", // 控制面板的实现，默认为值为：hover。click：点击 hover：停留 always
          useH5Prism: true,
          // skinLayout：功能组件布局配置，不传该字段使用默认布局
          skinLayout: [
            {
              name: "bigPlayButton",
              align: "cc",
              x: 0,
              y: 0,
            },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [
                {
                  name: "progress",
                  align: "blabs",
                  x: 0,
                  y: 44,
                },
                {
                  name: "playButton",
                  align: "tl",
                  x: 15,
                  y: 12,
                },
                {
                  name: "volume",
                  align: "tl",
                  x: 5,
                  y: 10,
                },
                {
                  name: "timeDisplay",
                  align: "tl",
                  x: 10,
                  y: 7,
                },
              ],
            },
          ],
        },
        (player) => {
          let video = null;
          console.log('初始化成功',video)
          // 判断视频和音频获取对应标签
          if (!this.isOrder) {
            if (params.format == "mp3") {
              video = document
                .getElementById("J_prismPlayer_courseVideo")
                .getElementsByTagName("audio")[0];
            } else {
              video = document
                .getElementById("J_prismPlayer_courseVideo")
                .getElementsByTagName("video")[0];
            }

            var timeDisplay;
            var tryTime;
            var percent;

            // 点击开始事件
            video.addEventListener("timeupdate", () => {
              //获取当前播放的时间
              if (video.currentTime == video.duration) {
                video.currentTime = 0;
              }
            });
          }
        }
      );

      this.player = player;
            }
    },
    dispose() {
      // 关闭窗口  关闭播放。
      this.player.dispose();
    },
  },
};
</script>
